
export interface DynamicFormConfig {
    title?: string;
    description?: string;
    substepTitle?: string;
    key?: HouseFormKey | OccupationFormKey | BottledGasFormKey | EnergySourceFormKey | CanalizedGasFormKey | any | null;
    type?: ComponentType | null;
    styleType?: CardStyleType | null;
    required?: boolean;
    isMultiSelection?: boolean;
    stepType?: string;
    allowComma?: boolean;
    dependency?: {
        key: HouseFormKey | CanalizedGasFormKey | ThermalSolarFormKey | PhotovoltaicSolarFormKey | HouseOptionalFormKey | null;
        value: string;
    };
    dependencyValues?: {
        key: HouseFormKey | CanalizedGasFormKey | ThermalSolarFormKey | PhotovoltaicSolarFormKey | HouseOptionalFormKey | null;
        value: string;
    };
    options?: {
        value: string | number;
        label: string;
        icon?: string;
        preSelected?: boolean;
        orientation?: 'portrait' | 'landscape';
    }[];
    label?: string;
    icon?: string;
    inputType?: string | null;
    tooltip?: string;
    displayType?: string;
    initialValue?: string;
    helpLabel?: {
        dependency?: {
            key: HouseFormKey | ThermalSolarFormKey | PhotovoltaicSolarFormKey | HouseOptionalFormKey | null;
            value: string;
        };
        label?: string;
    };
    conditionalNext?: {
        key: HouseFormKey | null;
        value: string;
    };
    groupedWith?: string[];
    errorMessage?: string;
    value?: string;
    min?: number;
    max?: number;
    child?: string;
    parentLabels?: any;
}

export enum CardStyleType {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    TERTIARY = "tertiary",
    QUATERNARY = "quaternary",
}

export enum BottledGasFormKey {
    BOTTLED_GAS_SIZE = "energySourcesBottleGas_bottleSize",
    BOTTLED_GAS_HOT_MONTH = "energySourcesBottleGas_nBottlesHotMonths",
    BOTTLED_GAS_MILD_MONTH = "energySourcesBottleGas_nBottlesMildMonths",
    BOTTLED_GAS_COLD_MONTH = "energySourcesBottleGas_nBottlesColdMonths",
}

export enum WoodFormKey {
    COLD_MONTH = "energySourcesWood_kgWoodColdMonths",
    MILD_MONTH = "energySourcesWood_kgWoodMildMonths",
    HOT_MONTH = "energySourcesWood_kgWoodHotMonths",
    USAGE = "energySourcesWood_usage",
    KILO_PRICE = "energySourcesWood_woodPriceKg",
}

export enum WoodFormValue {
    HEAT_WATER = "water_heating",
    HEAT_HOUSE = "space_heating",
    COOK = "cooking",
    OTHERS = "others",
}

export enum HouseFormKey {
    HOUSING_TYPE = "generalHouse_houseType",
    APARTMENT_FLOOR = "flatHouse_flatFloorType",
    HOME_TYPE = "villaHouse_villaType",
    NUMBER_FLOOR_IN_HOUSE = "villaHouse_numberFloors",
    USAGE_TYPE = "generalHouse_usageType",
    CONSTRUCTION_YEAR = "generalHouse_constructionYear",
    USEFUL_AREA = "generalHouse_usableArea",
}

export enum OccupationFormKey {
    HOUSE_OCCUPATION = "occupancy_numberResidents",
}

export enum PelletsFormKey {
    PELLETS_COLD_MONTH = "energySourcesPellets_kgPelletsColdMonths",
    PELLETS_MILD_MONTH = "energySourcesPellets_kgPelletsMildMonths",
    PELLETS_HOT_MONTH = "energySourcesPellets_kgPelletsHotMonths",
    PELLETS_PRICE = "energySourcesPellets_pelletsPriceKg",
    PELLETS_USAGE = "energySourcesPellets_usage",
}

export enum DieselFormKey {
    ANNUAL_CONSUPTION = "energySourcesDiesel_totalAnnualConsumptionLiter",
    ANNUAL_PRICE = "energySourcesDiesel_totalAnnualSpending",
    DIESEL_USAGE = "energySourcesDiesel_usage",
}

export enum ThermalSolarFormKey {
    PANELS_FEED = "energySourcesSolarThermal_type",
    PANELS_USAGE = "energySourcesSolarThermal_usage",
    PANELS_AMOUNT = "energySourcesSolarThermal_nPanelsTotal",
    PANELS_AREA = "energySourcesSolarThermal_areaEachPanelM2",
    IDK_APPROXIMATE_AREA = "energySourcesSolarThermal_areaEachPanelM2_idk",
    POOL_PANELS_AMOUNT = "energySourcesSolarThermal_nPanelsPool",
}

export enum EnergySourceFormKey {
    ENERGY_SOURCE = "energy-source",
}

export enum CanalizedGasFormKey {
    CANALIZED_GAS_TYPE = "energySourcesPipedGas_pipedGasType",
    AVERAGE_CONSUMPTION_TYPE = "energySourcesPipedGas_avgConsumption12M_unit",
    AVERAGE_CONSUMPTION = "energySourcesPipedGas_avgConsumption12M_value",
    MARKET_TYPE = "energySourcesPipedGas_naturalGasMarket",
    CONSUMPTION_SCALE = "energySourcesPipedGas_naturalGasTier",
}

export enum EquipamentsFormkey {
    EQUIPAMENT_OVEN = "kitchenEquipments_ovenEnergySource",
    EQUIPAMENT_STOVE = "kitchenEquipments_hobstoveEnergySource",
    EQUIPAMENT_TOASTER = "kitchenEquipments_nToaster",
    EQUIPAMENT_MICROWAVE = "kitchenEquipments_nMicrowave",
    EQUIPAMENT_COFFEE_MACHINE = "kitchenEquipments_nCoffeeMachine",
    EQUIPAMENT_KETTLE = "kitchenEquipments_nElectricKettle",
    EQUIPAMENT_AIR_FRYER = "kitchenEquipments_nAirFryer",
    EQUIPAMENT_IRON = "kitchenEquipments_nIron",
    EQUIPAMENT_BIMBY = "kitchenEquipments_nBimby",
    EQUIPAMENT_FRIDGE = "kitchenEquipments_nFridge",
    EQUIPAMENT_FRIDGE_FREEZER = "kitchenEquipments_nCombinedFridge",
    EQUIPAMENT_FRENCH_FRIDGE = "kitchenEquipments_nAmericanfrenchFridge",
    EQUIPAMENT_FREEZER = "kitchenEquipments_nFreezer",
    EQUIPAMENT_MINI_FRIDGE = "kitchenEquipments_nMinifridgeminibar",
    EQUIPAMENT_WINE_CELLAR = "kitchenEquipments_nWineRefrigerator",
    EQUIPAMENT_WITHOUT_EQUIPAMENTS = "kitchenEquipments_noEquipment",
}

export enum EquipamentsAirConditioningFormkey {
    EQUIPAMENT_UNDERFLOOR_HEATING = "climatizationEquipments_heatedPavementType",
    EQUIPAMENT_CENTRAL_HEATING_WITH_RADIATORS = "climatizationEquipments_nCentralHeatingRadiator",
    EQUIPAMENT_FIREPLACE = "climatizationEquipments_fireplaceType",
    EQUIPAMENT_AIR_CONDITIONING = "climatizationEquipments_nAirConditioner",
    EQUIPAMENT_DEHUMIDIFIER = "climatizationEquipments_nDehumidifier",
    EQUIPAMENT_FAN = "climatizationEquipments_nFan",
    EQUIPAMENT_ELECTRIC_HEATER = "climatizationEquipments_nPortableElectricHeater",
    EQUIPAMENT_GAS_CYLINDER_HEATER = "climatizationEquipments_nPortableBottledGasHeater",
    EQUIPAMENT_WITHOUT_EQUIPAMENTS = "climatizationEquipments_noEquipment",
}

export enum EquipamentsWaterHeatingFormKey {
    EQUIPAMENT_BOILER = "waterheatingEquipments_boilerEnergySource",
    EQUIPAMENT_HEATER = "waterheatingEquipments_instantBoilerEnergySource",
    EQUIPAMENT_THERMAL_ACCUMULATOR = "waterheatingEquipments_hasWaterStorage",
    EQUIPAMENT_THERMAL_ACCUMULATOR_HYBRID = "waterheatingEquipments_hasHybridWaterStorage",
    EQUIPAMENT_HEAT_PUMP = "waterheatingEquipments_hasHeatPump",
    EQUIPAMENT_WITHOUT_EQUIPAMENTS = "waterheatingEquipments_noEquipment",
}

export enum EquipamentWashingKey {
    EQUIPAMENT_DISHWASHER = "applianceMachineEquipments_hasDishWasher",
    EQUIPAMENT_WASHING_MACHINE = "applianceMachineEquipments_hasWashingMachine",
    EQUIPAMENT_DRYER = "applianceMachineEquipments_hasDryerMachine",
    EQUIPAMENT_WASHING_DRYER = "applianceMachineEquipments_hasWashingDryerMachine",
    EQUIPAMENT_WITHOUT_EQUIPAMENTS = "applianceMachineEquipments_noEquipment",
}

export enum EquipamentsEntertainmentFormKey {
    EQUIPAMENT_TV = "entertainmentEquipments_nTelevision",
    EQUIPAMENT_DIGITAL_BOX_TV = "entertainmentEquipments_nDigitalTVBox",
    EQUIPAMENT_GAME_CONSOLE = "entertainmentEquipments_nGameConsole",
    EQUIPAMENT_DVD = "entertainmentEquipments_nDvdBluray",
    EQUIPAMENT_LAPTOP = "entertainmentEquipments_nPortableLaptop",
    EQUIPAMENT_DESKTOP = "entertainmentEquipments_nPcDesktop",
    EQUIPAMENT_TABLET = "entertainmentEquipments_nTablet",
    EQUIPAMENT_ROUTER = "entertainmentEquipments_nRouter",
    EQUIPAMENT_WITHOUT_EQUIPAMENTS = "entertainmentEquipments_noEquipment",
}

export enum EquipamentsOtherFormKey {
    //otherEquipments_hasElectricOrHybridVehicle
    EQUIPAMENT_ELECTRIC_VEHICLE_HYBRID = "otherEquipments_hasElectricOrHybridVehicle",
    EQUIPAMENT_PRIVATE_POOL = "otherEquipments_hasPrivatePool",
    EQUIPAMENT_WELL_PUMP = "otherEquipments_hasWellPump",
    EQUIPAMENT_GARDEN_PUMP = "otherEquipments_hasGardenPump",
    EQUIPAMENT_WELL = "otherEquipments_hasWell",
    EQUIPAMENT_WITHOUT_EQUIPAMENTS = "otherEquipments_noEquipment",
    EQUIPAMENT_ELECTRIC_VEHICLE_HYBRID_CHARGER = "otherEquipments_electricVehicleChargingPlace",
    EQUIPAMENT_ELECTRIC_VEHICLE_HYBRID_CHARGER_WALLBOX = "otherEquipments_electicVehicleWallBox",
    EQUIPAMENT_ELECTRIC_VEHICLE_HYBRID_MOTOR_TYPE = "otherEquipments_electicVehicleMotorType",
    EQUIPAMENT_ELECTRIC_VEHICLE_HYBRID_QUANTITY = "otherEquipments_nElectricVehicleHybrid",
    EQUIPAMENT_ELECTRIC_VEHICLE_QUANTITY = "otherEquipments_nElectricVehicleElectric",
}

export enum HouseOptionalFormKey {
    WALL_INSULATION = "generalHouseOptional_thermalInsulationWalls",
    WALL_THICKNESS = "generalHouseOptional_thicknessWalls",
    ROOF_THERMALLY = "generalHouseOptional_thermalInsulationCeiling",
    ROOF_THERMALLY_CONCRETE = "generalHouseOptional_concreteCeiling",
    SUNSET_FACADE = "facade_sunsetFacade",
    OUTDOOR_FACADE = "facade_outdoorFacade",
    GLAZED_FACADE = "facade_glassFacade",
    GLASS_TYPE = "facade_prevalentGlassType"
}

export enum EquipamentFormValue {
    OVEN = "oven",
    STOVE = "stove",
    TOASTER = "toaster",
    MICROWAVE = "microwave",
    COFFEE_MACHINE = "coffee-machine",
    KETTLE = "kettle",
    AIR_FRYER = "air-fryer",
    IRON = "iron",
    BIMBY = "bimby",
    FRIDGE = "fridge",
    FRIDGE_FREEZER = "fridge-freezer",
    FRENCH_FRIDGE = "french-fridge",
    FREEZER = "freezer",
    MINI_FRIDGE = "mini-fridge",
    WINE_CELLAR = "wine-cellar",
    WITHOUT_EQUIPAMENTS = "true",
}

export enum EquipamentAirConditioningFormValue {
    UNDERFLOOR_HEATING = "climatizationEquipments_heatedPavementType",
    CENTRAL_HEATING_WITH_RADIATORS = "climatizationEquipments_nCentralHeatingRadiator",
    FIREPLACE = "climatizationEquipments_fireplaceType",
    AIR_CONDITIONING = "climatizationEquipments_nAirConditioner",
    DEHUMIDIFIER = "climatizationEquipments_nDehumidifier",
    FAN = "climatizationEquipments_nFan",
    ELECTRIC_HEATER = "climatizationEquipments_nPortableElectricHeater",
    GAS_CYLINDER_HEATER = "climatizationEquipments_nPortableBottledGasHeater",
    WITHOUT_EQUIPAMENTS = "true",
}

export enum EquipamentWaterHeatingFormValue {
    BOILER = "boiler",
    HEATER = "heater",
    THERMAL_ACCUMULATOR = "true",
    THERMAL_ACCUMULATOR_HYBRID = "true",
    HEAT_PUMP = "true",
    WITHOUT_EQUIPAMENTS = "true",
}

export enum EquipamentOtherFormValue {
    PRIVATE_POOL = "true",
    WELL = "true",
    WELL_PUMP = "true",
    GARDEN_PUMP = "true",
    ELECTRIC_VEHICLE_HYBRID = "electric-vehicle-hybrid",
    WITHOUT_EQUIPAMENTS = "true",
    ELECTRIC_VEHICLE_HYBRID_CHARGER_PUBLIC = "public_charger",
    ELECTRIC_VEHICLE_HYBRID_CHARGER_HOUSE = "private_charger_home",
    ELECTRIC_VEHICLE_HYBRID_CHARGER_CONDOMINIUM = "private_condominium_charge",
    ELECTRIC_VEHICLE_HYBRID_CHARGER_WALLBOX_YES = "true",
    ELECTRIC_VEHICLE_HYBRID_CHARGER_WALLBOX_NO = "false",
    ELECTRIC_VEHICLE_HYBRID_MOTOR_TYPE_HYBRID = "hybrid",
    ELECTRIC_VEHICLE_HYBRID_MOTOR_TYPE_ELECTRIC = "electric",
}

export enum EquipamentWashingFormValue {
    DISHWASHER = "true",
    WASHING_MACHINE = "true",
    DRYER = "true",
    WASHING_DRYER = "true",
    WITHOUT_EQUIPAMENTS = "true",
}

export enum EquipamentEntertainmentFormValue {
    TV = "tv",
    DIGITAL_BOX_TV = "digital-box-tv",
    GAME_CONSOLE = "game-console",
    DVD = "dvd",
    LAPTOP = "laptop",
    DESKTOP = "desktop",
    TABLET = "tablet",
    ROUTER = "router",
    WITHOUT_EQUIPAMENTS = "true",
}

export enum PhotovoltaicSolarFormKey {
    PANELS_FEED = "energySourcesSolarPV_type",
    PANELS_AMOUNT = "energySourcesSolarPV_panelsNumber",
    PANELS_POWER = "energySourcesSolarPV_systemPowerWp",
    IDK_PANELS_POWER = "energySourcesSolarPV_systemPowerWp_idk",
    INSTALLATION_YEAR = "energySourcesSolarPV_installationYear",
    HAS_BATTERY = "energySourcesSolarPV_hasBattery",
}

export enum HouseFormValue {
    APARTMENT = "apartment",
    HOUSING = "house",
    CAVE = "basement",
    GROUND_FLOOR = "ground_floor",
    MIDDLE_FLOOR = "intermediate_floors",
    LAST_FLOOR = "top_floor",
    SEMI_DETACHED = "semi_detached_house",
    ISOLATED = "isolated_house",
    CONSTRUCTION_YEAR = "construction-year",
    USEFUL_AREA = "useful-area",
    PERMANENT = "permanent",
    SEASONAL = "seasonal",
    BEFORE_1960 = "before_1960",
    BETWEEN_1990 = "1960_1989",
    BETWEEN_2021 = "1990_2021",
    AFTER_2021 = "after_2021",
    NUMBER_FLOOR_IN_HOUSE_1 = "1",
    NUMBER_FLOOR_IN_HOUSE_2 = "2",
    NUMBER_FLOOR_IN_HOUSE_3 = "3",
    NUMBER_FLOOR_IN_HOUSE_4 = "4",
    NUMBER_FLOOR_IN_HOUSE_5 = "5",
}

export enum OccupationFormValue {
    HOUSE_OCCUPATION_1 = 1,
    HOUSE_OCCUPATION_2 = 2,
    HOUSE_OCCUPATION_3 = 3,
    HOUSE_OCCUPATION_4 = 4,
    HOUSE_OCCUPATION_5 = 5,
    HOUSE_OCCUPATION_6 = 6,
    HOUSE_OCCUPATION_7 = 7,
    HOUSE_OCCUPATION_8 = 8,
    HOUSE_OCCUPATION_9 = 9,
    HOUSE_OCCUPATION_10 = 10,
}

export enum EquipamentToasterValue {
    TOASTER_VALUE_1 = 1,
    TOASTER_VALUE_2 = 2,
    TOASTER_VALUE_3 = 3,
    TOASTER_VALUE_4 = 4,
    TOASTER_VALUE_5 = 5,
    TOASTER_VALUE_PLUS_5 = 99,
}

export enum EquipamentMicrowaveValue {
    MICROWAVE_VALUE_1 = 1,
    MICROWAVE_VALUE_2 = 2,
    MICROWAVE_VALUE_3 = 3,
    MICROWAVE_VALUE_4 = 4,
    MICROWAVE_VALUE_5 = 5,
    MICROWAVE_VALUE_PLUS_5 = 99,
}

export enum EquipamentCoffeeMachineValue {
    COFFEE_MACHINE_VALUE_1 = 1,
    COFFEE_MACHINE_VALUE_2 = 2,
    COFFEE_MACHINE_VALUE_3 = 3,
    COFFEE_MACHINE_VALUE_4 = 4,
    COFFEE_MACHINE_VALUE_5 = 5,
    COFFEE_MACHINE_VALUE_PLUS_5 = 99,
}

export enum EquipamentKettleValue {
    KETTLE_VALUE_1 = 1,
    KETTLE_VALUE_2 = 2,
    KETTLE_VALUE_3 = 3,
    KETTLE_VALUE_4 = 4,
    KETTLE_VALUE_5 = 5,
    KETTLE_VALUE_PLUS_5 = 99,
}

export enum EquipamentAirFryerValue {
    AIR_FRYER_VALUE_1 = 1,
    AIR_FRYER_VALUE_2 = 2,
    AIR_FRYER_VALUE_3 = 3,
    AIR_FRYER_VALUE_4 = 4,
    AIR_FRYER_VALUE_5 = 5,
    AIR_FRYER_VALUE_PLUS_5 = 99,
}

export enum EquipamentIronValue {
    IRON_VALUE_1 = 1,
    IRON_VALUE_2 = 2,
    IRON_VALUE_3 = 3,
    IRON_VALUE_4 = 4,
    IRON_VALUE_5 = 5,
    IRON_VALUE_PLUS_5 = 99,
}

export enum EquipamentBimbyValue {
    BIMBY_VALUE_1 = 1,
    BIMBY_VALUE_2 = 2,
    BIMBY_VALUE_3 = 3,
    BIMBY_VALUE_4 = 4,
    BIMBY_VALUE_5 = 5,
    BIMBY_VALUE_PLUS_5 = 99,
}

export enum EquipamentFridgeValue {
    FRIDGE_VALUE_1 = 1,
    FRIDGE_VALUE_2 = 2,
    FRIDGE_VALUE_3 = 3,
    FRIDGE_VALUE_4 = 4,
    FRIDGE_VALUE_5 = 5,
    FRIDGE_VALUE_PLUS_5 = 99,
}

export enum EquipamentFridgeFreezerValue {
    FRIDGE_FREEZER_VALUE_1 = 1,
    FRIDGE_FREEZER_VALUE_2 = 2,
    FRIDGE_FREEZER_VALUE_3 = 3,
    FRIDGE_FREEZER_VALUE_4 = 4,
    FRIDGE_FREEZER_VALUE_5 = 5,
    FRIDGE_FREEZER_VALUE_PLUS_5 = 99,
}

export enum EquipamentFrenchFridgeValue {
    FRENCH_FRIDGE_VALUE_1 = 1,
    FRENCH_FRIDGE_VALUE_2 = 2,
    FRENCH_FRIDGE_VALUE_3 = 3,
    FRENCH_FRIDGE_VALUE_4 = 4,
    FRENCH_FRIDGE_VALUE_5 = 5,
    FRENCH_FRIDGE_VALUE_PLUS_5 = 99,
}

export enum EquipamentFreezerValue {
    FREEZER_VALUE_1 = 1,
    FREEZER_VALUE_2 = 2,
    FREEZER_VALUE_3 = 3,
    FREEZER_VALUE_4 = 4,
    FREEZER_VALUE_5 = 5,
    FREEZER_VALUE_PLUS_5 = 99,
}

export enum EquipamentMiniFridgeValue {
    MINI_FRIDGE_VALUE_1 = 1,
    MINI_FRIDGE_VALUE_2 = 2,
    MINI_FRIDGE_VALUE_3 = 3,
    MINI_FRIDGE_VALUE_4 = 4,
    MINI_FRIDGE_VALUE_5 = 5,
    MINI_FRIDGE_VALUE_PLUS_5 = 99,
}

export enum EquipamentWineCellarValue {
    WINE_CELLAR_VALUE_1 = 1,
    WINE_CELLAR_VALUE_2 = 2,
    WINE_CELLAR_VALUE_3 = 3,
    WINE_CELLAR_VALUE_4 = 4,
    WINE_CELLAR_VALUE_5 = 5,
    WINE_CELLAR_VALUE_PLUS_5 = 99,
}

export enum EquipamentCentralHeatingValue {
    CENTRAL_HEATING_VALUE_1 = 1,
    CENTRAL_HEATING_VALUE_2 = 2,
    CENTRAL_HEATING_VALUE_3 = 3,
    CENTRAL_HEATING_VALUE_4 = 4,
    CENTRAL_HEATING_VALUE_5 = 5,
    CENTRAL_HEATING_VALUE_PLUS_5 = 99,
}

export enum EquipamentAirConditioningValue {
    AIR_CONDITIONING_VALUE_1 = 1,
    AIR_CONDITIONING_VALUE_2 = 2,
    AIR_CONDITIONING_VALUE_3 = 3,
    AIR_CONDITIONING_VALUE_4 = 4,
    AIR_CONDITIONING_VALUE_5 = 5,
    AIR_CONDITIONING_VALUE_PLUS_5 = 99,
}

export enum EquipamentDehumidifierValue {
    DEHUMIDIFIER_VALUE_1 = 1,
    DEHUMIDIFIER_VALUE_2 = 2,
    DEHUMIDIFIER_VALUE_3 = 3,
    DEHUMIDIFIER_VALUE_4 = 4,
    DEHUMIDIFIER_VALUE_5 = 5,
    DEHUMIDIFIER_VALUE_PLUS_5 = 99,
}

export enum EquipamentFanValue {
    FAN_VALUE_1 = 1,
    FAN_VALUE_2 = 2,
    FAN_VALUE_3 = 3,
    FAN_VALUE_4 = 4,
    FAN_VALUE_5 = 5,
    FAN_VALUE_PLUS_5 = 99,
}

export enum EquipamentTvValue {
    TV_VALUE_1 = 1,
    TV_VALUE_2 = 2,
    TV_VALUE_3 = 3,
    TV_VALUE_4 = 4,
    TV_VALUE_5 = 5,
    TV_VALUE_PLUS_5 = 99,
}

export enum EquipamentDigitalTvValue {
    DIGITAL_TV_VALUE_1 = 1,
    DIGITAL_TV_VALUE_2 = 2,
    DIGITAL_TV_VALUE_3 = 3,
    DIGITAL_TV_VALUE_4 = 4,
    DIGITAL_TV_VALUE_5 = 5,
    DIGITAL_TV_VALUE_PLUS_5 = 99,
}

export enum EquipamentGameConsoleValue {
    GAME_CONSOLE_VALUE_1 = 1,
    GAME_CONSOLE_VALUE_2 = 2,
    GAME_CONSOLE_VALUE_3 = 3,
    GAME_CONSOLE_VALUE_4 = 4,
    GAME_CONSOLE_VALUE_5 = 5,
    GAME_CONSOLE_VALUE_PLUS_5 = 99,
}

export enum EquipamentDvdValue {
    DVD_VALUE_1 = 1,
    DVD_VALUE_2 = 2,
    DVD_VALUE_3 = 3,
    DVD_VALUE_4 = 4,
    DVD_VALUE_5 = 5,
    DVD_VALUE_PLUS_5 = 99,
}

export enum EquipamentLaptopValue {
    LAPTOP_VALUE_1 = 1,
    LAPTOP_VALUE_2 = 2,
    LAPTOP_VALUE_3 = 3,
    LAPTOP_VALUE_4 = 4,
    LAPTOP_VALUE_5 = 5,
    LAPTOP_VALUE_PLUS_5 = 99,
}

export enum EquipamentDesktopValue {
    DESKTOP_VALUE_1 = 1,
    DESKTOP_VALUE_2 = 2,
    DESKTOP_VALUE_3 = 3,
    DESKTOP_VALUE_4 = 4,
    DESKTOP_VALUE_5 = 5,
    DESKTOP_VALUE_PLUS_5 = 99,
}

export enum EquipamentTabletValue {
    TABLET_VALUE_1 = 1,
    TABLET_VALUE_2 = 2,
    TABLET_VALUE_3 = 3,
    TABLET_VALUE_4 = 4,
    TABLET_VALUE_5 = 5,
    TABLET_VALUE_PLUS_5 = 99,
}

export enum EquipamentRouterValue {
    ROUTER_VALUE_1 = 1,
    ROUTER_VALUE_2 = 2,
    ROUTER_VALUE_3 = 3,
    ROUTER_VALUE_4 = 4,
    ROUTER_VALUE_5 = 5,
    ROUTER_VALUE_PLUS_5 = 99,
}

export enum EquipamentGasCylinderValue {
    GAS_CYLINDER_VALUE_1 = 1,
    GAS_CYLINDER_VALUE_2 = 2,
    GAS_CYLINDER_VALUE_3 = 3,
    GAS_CYLINDER_VALUE_4 = 4,
    GAS_CYLINDER_VALUE_5 = 5,
    GAS_CYLINDER_VALUE_PLUS_5 = 99,
}

export enum EquipamentElectricHeaterValue {
    ELETRIC_HEATER_VALUE_1 = 1,
    ELETRIC_HEATER_VALUE_2 = 2,
    ELETRIC_HEATER_VALUE_3 = 3,
    ELETRIC_HEATER_VALUE_4 = 4,
    ELETRIC_HEATER_VALUE_5 = 5,
    ELETRIC_HEATER_VALUE_PLUS_5 = 99,
}

export enum EquipamentOthersHybridCarQuantityValue {
    HYBRID_CAR_1 = 1,
    HYBRID_CAR_2 = 2,
    HYBRID_CAR_3 = 3,
    HYBRID_CAR_4 = 4,
    HYBRID_CAR_5 = 5,
    HYBRID_CAR_PLUS_5 = 99,
}

export enum EquipamentOthersElectricCarQuantityValue {
    ELECTRIC_CAR_1 = 1,
    ELECTRIC_CAR_2 = 2,
    ELECTRIC_CAR_3 = 3,
    ELECTRIC_CAR_4 = 4,
    ELECTRIC_CAR_5 = 5,
    ELECTRIC_CAR_PLUS_5 = 99,
}

export enum EnergySourceFormValue {
    ELECTRICITY = "electricity",
    GAS = "gas",
    BOTTLE_GAS = "bottle-gas",
    THERMAL_SOLAR = "thermal-solar",
    PHOTOVOLTAIC_SOLAR = "photovoltaic-solar",
    DIESEL = "diesel",
    PELLETS = "pellets",
    WOOD = "wood",
}

export enum CanalizedGasFormValue {
    NATURAL_GAS = "natural_gas",
    PROPANE_GAS = "propane_gas",
    CUBIC_METERS = "m3",
    KILOWATT_HOUR = "kwh",
    FREE = "free_market",
    REGULATED = "regulated_market",
    SCALE_1 = "tier_1",
    SCALE_2 = "tier_2",
    SCALE_3 = "tier_3",
    SCALE_4 = "tier_4",
}

export enum BottledGasFormValue {
    SIZE_BOTTLED_GAS_SMALL = "small",
    SIZE_BOTTLED_GAS_MEDIUM = "medium",
    SIZE_BOTTLED_GAS_LARGE = "large",
}

export enum PelletsFormValue {
    HEATING_WATER = "water_heating",
    HEATING_HOUSE = "space_heating",
    COOK = "cooking",
    OTHERS = "others",
}

export enum DieselFormValue {
    HEATING_WATER = "water_heating",
    HEATING_HOUSE = "space_heating",
    COOK = "cooking",
    HEATING_POOL = "pool_heating",
    OTHERS = "others",
}

export enum ThermalSolarFormValue {
    FEED_YOUR_HOUSE = "own_consumption",
    FEED_MANY_HOUSES = "several_fractions",
    HEAT_HOUSE = "space_heating",
    HEAT_WATER = "water_heating",
    HEAT_POOL = "pool_heating",
    IDK_APPROXIMATE_AREA = "-1",
}

export enum PhotovoltaicSolarFormValue {
    FEED_YOUR_HOUSE = "own_consumption",
    FEED_MANY_HOUSES = "several_fractions",
    IDK_PANELS_POWER = "-1",
    HAS_BATTERY = "true",
    NO_BATTERY = "false",
}

export enum ComponentType {
    CARD = "card",
    INPUT = "input",
    RADIO = "radio",
    CHECKBOX = "checkbox",
    SELECT = "select",
}

export enum HouseOptionalFormValue {
    WALL_INSULATION_YES = "true",
    WALL_INSULATION_NO = "false",
    WALL_INSULATION_UNKNOWN = "unknown",
    WALL_THICKNESS_0_20 = "0-20",
    WALL_THICKNESS_20_30 = "20-30",
    WALL_THICKNESS_30_40 = "30-40",
    WALL_THICKNESS_40_60 = "40-60",
    WALL_THICKNESS_ABOVE_60 = "above-60",
    WALL_THICKNESS_UNKNOWN = "unknown",
    ROOF_THERMALLY_YES = "true",
    ROOF_THERMALLY_NO = "false",
    ROOF_THERMALLY_UNKNOWN = "unknown",
    ROOF_THERMALLY_CONCRETE_YES = "true",
    ROOF_THERMALLY_CONCRETE_NO = "false",
    ROOF_THERMALLY_CONCRETE_UNKNOWN = "unknown",
    SUNSET_FACADE_1 = "facade_1",
    SUNSET_FACADE_2 = "facade_2",
    SUNSET_FACADE_3 = "facade_3",
    SUNSET_FACADE_4 = "facade_4",
    OUTDOOR_FACADE_1 = "facade_facade1_exposed",
    OUTDOOR_FACADE_2 = "facade_facade2_exposed",
    OUTDOOR_FACADE_3 = "facade_facade3_exposed",
    OUTDOOR_FACADE_4 = "facade_facade4_exposed",
    GLAZED_FACADE_PREDOM = "predom_glazed",
    GLAZED_FACADE_MOSTLY = "mostly_glazed",
    GLAZED_FACADE_EQUIVALENT = "equivalent",
    GLAZED_FACADE_MOSTLY_WALL = "mostly_wall",
    GLAZED_FACADE_PREDOM_WALL = "predom_wall",
    GLASS_TYPE_SINGLE = "single",
    GLASS_TYPE_DOUBLE_OR_TRIPLE = "double_or_triple",
    GLASS_TYPE_UNKNOWN = "unknown"
}

export interface DynamicFormValue {
    value: any;
    valid: boolean;
}

export enum StepType {
    STEP = "step",
    ENERGY_SOURCE_SUBSTEP_TYPE = "energySourceSubstepType",
    EQUIPAMENTS_SUBSTEP_TYPE = "equipamentsSubstepType",
}

export enum Navigation {
    NAVIGATION_STEP = "navigationStep",
    ENERGY_SOURCE_SUBSTEP = "energySourceSubstep",
    EQUIPAMENTS_SUBSTEP = "equipamentsSubstep",
}

export enum DefineHouseResumeId {
    HOUSE = 1,
    OCCUPATION = 2,
    ENERGY_SOURCE = 3,
    EQUIPAMENTS = 4,
}

export interface DefineHouseServiceResponse {
    contract: any;
    house: any;
    resume: any;
}

export class DefineHouseFactory {
    protected getEnergySources(answers: any): string[] {
        const energySourcesMap = {
            energySources_hasBottledGas: "bottle-gas",
            energySources_hasDiesel: "diesel",
            energySources_hasElectricity: "electricity",
            energySources_hasPellets: "pellets",
            energySources_hasPipedGas: "gas",
            energySources_hasSolarPV: "photovoltaic-solar",
            energySources_hasSolarThermal: "thermal-solar",
            energySources_hasWood: "wood",
        };

        return Object.keys(energySourcesMap)
            .filter(key => answers[key] === "true")
            .map(key => energySourcesMap[key]);
    }

    static create(answers: any) {
        const energySources = new DefineHouseFactory().getEnergySources(answers);
        if (energySources.length) {
            answers["energy-source"] = energySources;
        }

        Object.keys(answers).forEach(key => {
            if (typeof answers[key] === "string" && answers[key].startsWith("[")) {
                answers[key] = JSON.parse(answers[key]);
            }
        });

        if (answers[ThermalSolarFormKey.PANELS_AREA] && answers[ThermalSolarFormKey.PANELS_AREA] === "-1") {
            answers[ThermalSolarFormKey.PANELS_AREA] = 0;
            answers[ThermalSolarFormKey.IDK_APPROXIMATE_AREA] = "-1";
        }

        if (answers[PhotovoltaicSolarFormKey.PANELS_POWER] && answers[PhotovoltaicSolarFormKey.PANELS_POWER] === "-1") {
            answers[PhotovoltaicSolarFormKey.PANELS_POWER] = null;
            answers[PhotovoltaicSolarFormKey.IDK_PANELS_POWER] = "-1";
        }

        return {
            ...answers,
        };
    }
}
